import React from "react";
import HeroSlide from "./HeroSlide";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import "./HeroSlider.css";

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

import bg1 from "../../assets/images/ll.jpg";

const HeroSlider: React.FC = () => {
    const btnText = "Čítajte viac";

    return (
        <section className="hero-slider hero-style-2">
            <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                loop={true}
                centeredSlides={true}
                slidesPerView={1}
                spaceBetween={1}
                autoplay={{
                    delay: 100000,
                    disableOnInteraction: false,
                }}
                pagination={{ clickable: true }}
                navigation={false}
                breakpoints={{
                    0: {
                        slidesPerView: 1
                    },
                    600: {
                        slidesPerView: 1
                    },
                    1000: {
                        slidesPerView: 1
                    }
                }}
                className="swiper-container"
            >
                <SwiperSlide>
                    <HeroSlide
                        background={bg1}
                        dataText="<i class='fi flaticon-wounded'></i>Personal injury plan<h4>Personal Injury</h4>"
                        titleText="Ľubomír Luhový"
                        slideText="<p>Kandidát na primátora mesta Púchov<br>Úcta a pohyb spájajú generácie – SPOLU PRE PÚCHOV</p>"
                        buttonText={btnText}
                        buttonLink="#nase-zameranie"
                    />
                </SwiperSlide>
                <SwiperSlide>
                    <HeroSlide
                        background={bg1}
                        dataText="<i class='fi flaticon-dog'></i>Family Law plan<h4>Family Law</h4>"
                        titleText="MOJE HODNOTY A VÍZIA PRE PÚCHOV"
                        slideText="<p>Neprichádzam s agresívnymi sloganmi ani prázdnymi politickými frázami.<br> Chcem pre Púchov poctivo pracovať na základe týchto pilierov</p>"
                        buttonText={btnText}
                        buttonLink="/advokatska-kancelaria-puchov"
                    />
                </SwiperSlide>
                <SwiperSlide>
                    <HeroSlide
                        background={bg1}
                        dataText="<i class='fi flaticon-thief'></i>Criminal plan<h4>Criminal Law</h4>"
                        titleText="ZÁVÄZOK VOLIČOM"
                        slideText="<p>Nechcem sľubovať nemožné veci. Ponúkam Vám poctivú prácu, slušnosť, pokojný prístup bez zbytočných hádok a dôraz na reálne výsledky. Verím, že Púchov môže byť moderným, pokojnejším a dôstojným mestom pre všetky generácie.</p>"
                        buttonText={btnText}
                        buttonLink="/podla-odvetvia/pravo-nehnutelnosti"
                    />
                </SwiperSlide>
            </Swiper>
        </section>
    );
}

export default HeroSlider;